import * as AvatarPrimitive from "@radix-ui/react-avatar";

import { cn, platformProps } from "../../lib";
import type {
  AvatarFallbackPrimitiveProps,
  AvatarImagePrimitiveProps,
  AvatarRootPrimitiveProps,
} from "./types";

function Avatar({
  className,
  // `alt` lives on the Root in the native (@rn-primitives) avatar API. Accept it here
  // for a unified cross-platform contract and drop it on web (Radix Root has no `alt`).
  alt: _alt,
  testID,
  children,
  ...injected
}: AvatarRootPrimitiveProps) {
  return (
    <AvatarPrimitive.Root
      // "avatar" is the atom's root; this one sits inside it, beside
      // avatar-image and avatar-fallback
      {...platformProps({ testID, slot: "avatar-root" })}
      className={cn("rounded-radius-full relative flex shrink-0 overflow-hidden", className)}
      {...injected}
    >
      {children}
    </AvatarPrimitive.Root>
  );
}

function AvatarImage({
  className,
  src,
  alt,
  onLoadingStatusChange,
  testID,
  ...injected
}: AvatarImagePrimitiveProps) {
  return (
    <AvatarPrimitive.Image
      {...platformProps({ testID, slot: "avatar-image" })}
      className={cn("aspect-square size-full object-cover", className)}
      src={src}
      alt={alt}
      // Only the states native reports too
      onLoadingStatusChange={(status) => {
        if (status === "loaded" || status === "error") onLoadingStatusChange?.(status);
      }}
      {...injected}
    />
  );
}

function AvatarFallback({
  className,
  children,
  delayMs,
  testID,
  ...injected
}: AvatarFallbackPrimitiveProps) {
  return (
    <AvatarPrimitive.Fallback
      {...platformProps({ testID, slot: "avatar-fallback" })}
      className={cn("rounded-radius-full flex size-full items-center justify-center", className)}
      delayMs={delayMs}
      {...injected}
    >
      {children}
    </AvatarPrimitive.Fallback>
  );
}

export { Avatar, AvatarImage, AvatarFallback };
